<template>
  <calm-page extra-class="comm" :title="$t('menu.comm')">
    <template slot="actions">
      <calm-button variant="primary" @click="handleCreate()">
        <i class="fas fa-plus mr-1"></i> {{ $t("new") }}
      </calm-button>
    </template>

    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar :hide-actions="true">
      <calm-field :label="$t('search')">
        <input
          v-model="searchQuery"
          type="text"
          class="ed"
          :placeholder="$t('search')"
        />
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ MAIN LIST TABLE (skin the el-table verbatim, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
          <el-table-column :label="$t('lmg.comm')">
          <template slot-scope="{ row }" class="d-flex">
            {{ row.Name }}
          </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.ttype')">
          <template slot-scope="{  row }" class="d-flex">
            {{ row.TransactionTypeName }}
          </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('lmg.insure')">
          <template slot-scope="{  row }" class="d-flex">
            {{ row.InsuranceName }}
          </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.comm')">
          <template slot-scope="{  row }" class="d-flex">
            {{ row.Commission }}
          </template>
          </el-table-column> -->



          <!-- <el-table-column :label="$t('lmg.comm_limitCnt')">
          <template slot-scope="{ $index, row }" class="d-flex">
            {{ row.LimitCnt }}
          </template>
          </el-table-column> -->


        <el-table-column
          align="right"
          :label="$t('actions')"
        >
          <div slot-scope="{ $index, row }" class="comm__rowact">
             <calm-button
              variant="soft"
              size="sm"
              @click="handleEdit($index, row)"
            >
              <i class="fa fa-edit mr-1"></i> คอมมิชชั่นโปรไฟล์
            </calm-button>
            <calm-button
              variant="soft"
              size="sm"
              @click="handleEditExtra($index, row)"
            >
              <i class="fa fa-edit mr-1"></i> ประเภทประกัน
            </calm-button>
            <calm-button
              variant="danger"
              size="sm"
              icon-only
              @click="handleDelete($index, row)"
            >
              <i class="fa fa-trash"></i>
            </calm-button>
          </div>
        </el-table-column>
      </el-table>
    </calm-table>

    <!-- ═══════════════ PROFILE (level 1) MODAL ═══════════════ -->
    <calm-modal
      :show.sync="showAddModal"
      :title="$t('lmg.comm')"
      :show-footer="false"
    >
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="comm__form" @submit.prevent="handleSubmit(onUpdateComm)">
        <base-input :label="$t('name')" v-model="md.Name" :name="$t('name')" rules="required"> </base-input>

        <base-input :label="$t('lmg.ttype')"  :name="$t('lmg.ttype')" rules="required" v-if="md.ID == 0">
          <el-select v-model="md.TransactionTypeID" :placeholder="$t('lmg.ttype')">
            <el-option
              v-for="option in ttype"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input    :label="$t('lmg.insure_type')"  :name="$t('lmg.insure_type')" rules="required"  v-if="false">
          <el-select v-model="md.InsuranceID" :placeholder="$t('lmg.insure_type')">
            <el-option
              v-for="option in insure"
              :key="option.ID"
              :label="option.ShowName"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input  v-if="false" :label="$t('lmg.comm_amount') + ' (%)'" v-model="md.Commission"  :name="$t('lmg.comm_amount')" rules="required|numeric">
        </base-input>

        <!-- <base-input :label="$t('lmg.comm_incentive')" v-model="md.Incentive"  :name="$t('lmg.comm_incentive')" rules="required|numeric">
        </base-input> -->

        <base-input v-if="false" :label="$t('lmg.comm_limitCnt')" v-model="md.LimitCnt"  :name="$t('lmg.comm_limitCnt')" rules="required|numeric">
        </base-input>

      <div class="calm__modal__actions">
        <calm-button
          variant="ghost"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </calm-button>
        <calm-button
          variant="primary"
          native-type="submit"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </calm-button>
      </div>
      </form>
      </validation-observer>

    </calm-modal>


    <!-- ═══════════════ EXTRA (level 2/3) MODAL — nested commission math editor ═══════════════ -->
    <!-- CAUTION: the el-table + input grid below is the commission rate/cap editor.
         Its markup, v-models and validation are kept intact; only the surrounding
         modal chrome is Calm-ified. -->
    <calm-modal
      :show.sync="showExtraModal"
      size="lg"
      :show-footer="false"
    >
    <validation-observer v-slot="{handleSubmit}" ref="fromCommExtra">
      <form class="comm__form" @submit.prevent="handleSubmit(onCreateExtra)">
      <h1 class="comm__modal-title">คอมมิชชั่นโปรไฟล์ : {{ md.Name }}</h1>

      <el-table
        :data="tableCommExtra"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
      >
        <!-- Record paidvia   note bank amount -->
        <el-table-column :label="$t('lmg.insure_type')" min-width="200">
          <template slot-scope="{ row }">
            {{ row.InsuranceShowName }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.comm_amount_percent')">
          <template slot-scope="{ row }">
            {{ row.Commission }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.comm_limitCnt')">
          <template slot-scope="{ row }">
            {{ row.LimitCnt }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('action')">
          <template slot-scope="{ row }">
              <base-button
                @click.native="handleDeleteCommExtra($index, row)"
                class="edit"
                type="danger"
                size="sm"
                icon
              >
                <i class="fa fa-trash"></i>
              </base-button>
              <!-- pay button -->
            </template>
        </el-table-column>
      </el-table>


      <div class="row">
        <div class="col-lg-12">
      <base-input    :label="$t('lmg.insure_type')"  :name="$t('lmg.insure_type')" >
          <el-select v-model="md.InsuranceID" :placeholder="$t('lmg.insure_type')" filterable>
            <el-option
              v-for="option in insureUpper"
              :key="option.ID"
              :label="option.ShowName"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
        <base-input  :label="$t('lmg.comm_amount') + ' (%)'" v-model="md.Commission"  :name="$t('lmg.comm_amount')" rules="required|numeric">
        </base-input>
        </div>
        <div class="col-lg-6">
        <base-input :label="$t('lmg.comm_limitCnt')" v-model="md.LimitCnt"  :name="$t('lmg.comm_limitCnt')" rules="required|numeric">
        </base-input>
        </div>
      </div>
      <div class="calm__modal__actions">
        <calm-button type="button" variant="ghost" @click="showExtraModal = false" >
          {{ $t("close") }}
        </calm-button>
        <calm-button
          variant="primary"
          native-type="submit"
        >
          {{ $t("save") }}
        </calm-button>
      </div>

      </form>
</validation-observer>

    </calm-modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Comm/getData",
      tableCommExtra: "Comm/getDataExtra",
      ttype: "Ttype/getData",
      insure: "Insure/getData",
      insureUpper: "Insure/getUpper"
    }),
    tableData: function() {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    }
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      showExtraModal: false,
      md: {
        ID: 0,
        BranchName: "",
        Name: "",
        TransactionTypeID: "",
        TransactionTypeName: "",
        InsuranceID: "",
        InsuranceName: "",
        Commission: "",
        Incentive: 0,
        LimitCnt: "" 
      }
    };
  },
  async mounted() {
    await this.listData();
    await this.listTtypeData();
    await this.listInsureUpper();
  },
  methods: {
    ...mapActions({
      createData: "Comm/createData",
      createExtraData: "Comm/createExtraData",
      updateData: "Comm/updateData",
      deleteData: "Comm/deleteData",
      deleteExtraData: "Comm/deleteExtraData",
      listData: "Comm/listData",
      listExtraData: "Comm/listExtraData",
      listTtypeData: "Ttype/listData",
      listInsureData: "Insure/listData",
      listInsureUpper: "Insure/listUpper"
    }),
    handleCreate() {
      this.showAddModal = true;
      this.md.ID = 0;
      this.md.BranchName = "";
      this.md.Name = "";
      this.md.TransactionTypeID = "";
      this.md.TransactionTypeName = "";
      this.md.InsuranceID = "";
      this.md.InsuranceName = "";
      this.md.Commission = "";
      this.md.Incentive = 0;
      this.md.LimitCnt = ""; 
    },
    handleEdit(index, row) {

      this.showAddModal = true;
      this.md.ID = row.ID;
      this.md.BranchName = row.BranchName;
      this.md.Name = row.Name;
      this.md.TransactionTypeID = row.TransactionTypeID;
      this.md.TransactionTypeName = row.TransactionTypeName;
      this.md.InsuranceID = row.InsuranceID;
      this.md.InsuranceName = row.InsuranceName;
      this.md.Commission = row.Commission;
      this.md.Incentive = row.Incentive;
      this.md.LimitCnt = row.LimitCnt;
    },
    handleEditExtra(index, row) {

      this.showExtraModal = true;
      this.md.Name = row.Name;
      this.md.ID = row.ID
      this.listExtraData(row.ID)

      // this.$router.push({name:`CommExtraList`,query: { id : row.ID}})
      // this.md.ID = row.ID;
      // this.md.BranchName = row.BranchName;
      // this.md.Name = row.Name;
      // this.md.TransactionTypeID = row.TransactionTypeID;
      // this.md.TransactionTypeName = row.TransactionTypeName;
      // this.md.InsuranceID = row.InsuranceID;
      // this.md.InsuranceName = row.InsuranceName;
      // this.md.Commission = row.Commission;
      // this.md.Incentive = row.Incentive;
      // this.md.LimitCnt = row.LimitCnt;
    },
    onCreateExtra(){
      this.createExtraData({
          comProfileID: this.md.ID,
          insuranceID: this.md.InsuranceID,
          commission: this.md.Commission,
          limitCnt: this.md.LimitCnt
        }).then(resp => {
            this.listExtraData(this.md.ID);
            this.md.Commission = ""
            this.md.limitCnt = ""
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });

    },
    onUpdateComm() {
      this.showAddModal = false;

      if (this.md.ID == 0) {
        // create
        this.createData({
          name: this.md.Name,
          transactionTypeID: this.md.TransactionTypeID,
          // insuranceID: this.md.InsuranceID,
          // commission: this.md.Commission,
          // incentive: this.md.Incentive,
          // limitCnt: this.md.LimitCnt
        })
          .then(resp => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      } else {
        // update

        this.updateData({
          ID: this.md.ID,
          name: this.md.Name,
          commission: this.md.Commission,
          incentive: this.md.Incentive,
          limitCnt: this.md.LimitCnt
        })
          .then(resp => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      }
    },
    handleDeleteCommExtra(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.InsuranceShowName,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteExtraData({
              ID: row.ID
            })
              .then(resp => {
                this.listExtraData(this.md.ID);
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              ID: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style scoped>
/* Commission profile editor — Calm skin. Namespaced under .comm so nothing
   leaks to other pages. The el-tables (main list + nested math editor) are
   kept verbatim (§11 "skin, don't rewrite") and re-styled only via deep
   selectors below. The nested rate/cap input grid inside the Extra modal is
   left structurally intact; only its surrounding chrome is Calm-ified. */

/* Row-action cell: keep the three action buttons inline + right-aligned. */
.comm__rowact {
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

/* Modal form spacing. */
.comm__form >>> .form-group {
  margin-bottom: 16px;
}
.comm__form .calm__modal__actions {
  margin-top: 8px;
}

/* Title inside the nested (Extra) modal — replaces the old bare <h1>. */
.comm__modal-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--c-text, #2c3e50);
}

/* The free-text search box reuses the Kit's .ed input look. */
.comm >>> .ed {
  width: 100%;
}

/* Skin the existing <el-table>s (both the main list and the nested math
   editor) so they read as Calm surfaces without touching column definitions
   or slots (§11). Deep selectors only; scoped to .comm. */
.comm >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.comm >>> .el-table th,
.comm >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.comm >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.comm >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.comm >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}

/* The Extra modal also hosts an el-table inside the calm__modal (which is
   portaled to <body>, outside the .comm root). Re-skin it via the modal box
   so the nested math-editor grid matches the Calm look. The modal root
   carries the `calm` class, so --c-* tokens resolve. */
.comm >>> .el-table .el-table__empty-block {
  background: transparent;
}
</style>
